import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { HomeLayout } from '../../components/Workspaces/HomeLayout';
import { WorkspacesRoute } from '../../components/Workspaces/WorkspacesRoute';
import { DSRoutes } from '../../constants/routes';
import { useCustomNavigate } from '../../hooks/useCustomNavigate';
import { useDeeplinkNavigate } from '../../hooks/useDeeplinkNavigate';
import { DemoSwitchScreen } from '../../screens/DemoSwitchScreen';
import { useTabs, useUser } from '../../store/context';
import { AnalyticsDashboard } from '../AnalyticsDahsboard';
import { CloneScreen } from '../ClonePage/ClonePage';
import { NotificationsSettings } from '../NotificationsSettings';
import { PlaybookPage } from '../PlaybookPage/PlaybookPage';
import { TeamActivityPage } from '../TeamActivityPage';
import { TourScreen } from '../TourPage/TourPage';
import { WorkspaceGate } from '../WorkspaceGate/WorkspaceGate';
import { WorkspaceScreen } from '../WorkspacePage';
import { ConsoleScreen } from './ConsoleScreen';
import { HomeScreenLayout } from './HomeScreenLayout';

export const HomeScreenRoutes = () => {
  const { navigateToRoute } = useCustomNavigate();
  const { redirectRoute, setRedirectRoute } = useTabs();
  const { activeOrganization } = useUser();

  useDeeplinkNavigate();

  useEffect(() => {
    if (redirectRoute) {
      navigateToRoute(redirectRoute);
      setRedirectRoute('');
    }
  }, [redirectRoute, activeOrganization?.id]);

  return (
    <Routes>
      <Route
        path={DSRoutes.HOME}
        element={<HomeScreenLayout />}
      >
        <Route element={<HomeLayout />}>
          <Route
            index
            element={<ConsoleScreen />}
          />
        </Route>
        <Route
          path="*"
          element={<HomeLayout />}
        >
          <Route
            path={DSRoutes.WORKSPACES}
            element={<WorkspacesRoute />}
          />
          <Route
            path={DSRoutes.WORKSPACE}
            element={<WorkspaceGate />}
          >
            <Route
              path={DSRoutes.TOUR_PAGE}
              element={<TourScreen />}
            />
            <Route
              path={DSRoutes.DEMO_PAGE}
              element={<DemoSwitchScreen />}
            />
            <Route
              path={DSRoutes.CLONE_PAGE}
              element={<CloneScreen />}
            />
            <Route
              path={DSRoutes.PLAYBOOK_PAGE}
              element={<PlaybookPage />}
            />
            <Route
              path="*"
              element={<WorkspaceScreen />}
            />
          </Route>
          <Route
            path="dashboard"
            element={<AnalyticsDashboard />}
          />
          <Route
            path={DSRoutes.TEAM_ACTIVITIES}
            element={<TeamActivityPage />}
          />
          <Route
            path={DSRoutes.NOTIFICATIONS_SETTINGS}
            element={<NotificationsSettings />}
          />
        </Route>
      </Route>
    </Routes>
  );
};
